import { CompressionPreset } from './types';

export const COMPRESSION_PRESETS: Record<string, CompressionPreset> = {
  web: {
    name: 'Web Optimized',
    video: {
      codec: 'h264',
      crf: 28,
      resolution: { width: 1280, height: 720 },
      audio: { codec: 'aac', bitrate: '128k' }
    },
    image: {
      quality: 0.8,
      maxWidth: 1920,
      format: 'auto',
      progressive: true
    }
  },
  mobile: {
    name: 'Mobile Friendly',
    video: {
      codec: 'h264',
      crf: 32,
      resolution: { width: 854, height: 480 },
      audio: { codec: 'aac', bitrate: '96k' }
    },
    image: {
      quality: 0.7,
      maxWidth: 1280,
      format: 'auto'
    }
  },
  social: {
    name: 'Social Media',
    video: {
      codec: 'h264',
      crf: 30,
      resolution: { width: 1080, height: 1080 },
      audio: { codec: 'aac', bitrate: '128k' }
    },
    image: {
      quality: 0.75,
      maxWidth: 1080,
      format: 'auto'
    }
  },
  email: {
    name: 'Email Attachment',
    video: {
      codec: 'h264',
      crf: 35,
      resolution: { width: 640, height: 360 },
      audio: { codec: 'aac', bitrate: '64k' }
    },
    image: {
      quality: 0.6,
      maxWidth: 800,
      format: 'auto'
    }
  }
};

export function getPreset(presetName: string): CompressionPreset | undefined {
  return COMPRESSION_PRESETS[presetName];
}

export function listPresets(): string[] {
  return Object.keys(COMPRESSION_PRESETS);
}
